var _circle, _circle2, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7_5730)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 50,
    r: 40,
    fill: "url(#paint0_radial_7_5730)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_5730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 10,
    width: 80,
    height: 80
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 50,
    r: 40,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_5730)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71 86C47 58.8 21.6667 52.6666 12 53C2.33338 53.3333 19 113 19 113C46.3334 115.333 95 113.2 71 86Z",
    fill: "#28BA76",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-185.435 154.319C-128.856 78.1271 -70.604 90.4899 -40.5823 72.2751C-6.52577 51.6136 15.3722 49.8641 32.793 56.7344C35.464 57.7881 38.0306 59.046 40.5188 60.4668M292.606 186C214.838 77.7293 174.839 123.534 132.714 118.289C121.216 116.858 111.457 113.561 102.86 109.173M102.86 109.173C97.4103 108.955 83.7127 110.278 72.5203 117.305M102.86 109.173C100.232 107.831 97.7114 106.387 95.2846 104.862M95.2846 104.862C77.8884 102.99 61.9453 112.588 34.779 118.288M95.2846 104.862C92.6857 103.229 90.1929 101.506 87.7845 99.7164M87.7845 99.7164C73.6799 98.248 51.894 109.173 28.5968 114.377M87.7845 99.7164C86.0136 98.4016 84.2887 97.05 82.6022 95.6738M8.81989 117.305C55.8399 106.412 67.6129 93.8014 82.6007 95.6738C80.6163 94.0564 78.6856 92.4037 76.7948 90.7357M6.78629 116.279C43.1176 105.347 52.5929 90.7357 76.7963 90.7357C76.0775 90.1013 75.3649 89.467 74.6583 88.8281M74.6583 88.8281C40.4113 86.4381 38.9429 103.125 -1.46635 116.277M74.6583 88.8281C73.3912 87.6868 72.1409 86.541 70.9014 85.3967M70.9014 85.3967C34.7789 79.9748 24.6094 106.789 -15.3759 118.288M70.9014 85.3967C69.4361 84.0436 67.9892 82.6919 66.55 81.351M66.55 81.351C6.78476 81.351 25.6508 95.6738 -15.3759 109.173C-40.0939 117.305 -55.8927 98.8624 -96.4356 116.279M66.55 81.351C64.7422 79.6646 62.9513 77.9965 61.1619 76.3623M-107.219 118.288C-81.8686 93.5265 -39.2108 116.279 -10.5745 97.8072C28.7227 72.4594 47.0696 75.7756 61.1635 76.3623C59.8825 75.1934 58.603 74.0415 57.319 72.9125M57.319 72.9125C57.319 72.9125 17.561 63.6109 -25.5992 94.6877C-49.947 112.221 -88.3841 93.4728 -113.727 117.305M57.319 72.9125C55.5527 71.3612 53.7802 69.856 51.9862 68.4153M51.9862 68.4153C51.9862 68.4153 16.5227 55.7483 -29.3162 88.8281C-52.8638 105.822 -99.4322 93.4728 -123.639 117.305M51.9862 68.4153C50.4057 67.1451 48.8083 65.9255 47.1879 64.7659M47.1879 64.7659C47.1879 64.7659 17.4719 54.4766 -15.3759 75.8785C-65.5031 108.537 -95.2974 87.2921 -137.018 119.582M47.1879 64.7659C45.0161 63.213 42.7997 61.7692 40.5188 60.4668M40.5188 60.4668C40.5188 60.4668 8.81988 48.7106 -27.8724 77.4759C-53.1817 97.3157 -103.175 87.4211 -137.793 117.305M32.793 56.7359C-10.5761 49.6199 -29.3162 79.0072 -99.4322 93.4743C-122.244 101.515 -135.174 106.628 -143.308 118.289",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-185.435 146.775C-108.794 58.0889 -81.6536 87.6129 -40.5823 64.7319C60.9684 8.15673 54.2409 103.975 132.184 113.683C174.309 118.929 217.912 79.7104 292.606 178.455",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-183.116 140.59C-106.475 51.9043 -78.9298 82.1425 -38.264 58.5472C61.5465 0.634318 58.0753 98.9227 136.019 108.63C178.143 113.875 221.78 76.6208 299.546 184.891",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-183.116 135.216C-97.6315 47.722 -78.4137 76.18 -37.7479 52.5848C62.0626 -5.32818 59.3548 93.2935 137.298 102.999C179.423 108.244 221.78 71.245 299.546 179.516",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-183.116 130.097C-93.5366 43.3717 -80.0695 70.9174 -38.7709 46.9551C61.0397 -10.9579 61.4022 87.4073 139.345 97.1145C181.47 102.361 221.781 66.1283 299.548 174.4",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-183.361 122.192C-107.611 48.2331 -79.8108 65.7982 -38.5153 41.8359C58.85 -14.6578 62.1707 81.7767 140.114 91.4839C182.239 96.7291 221.78 61.7771 299.547 170.048",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186 115.491C-111.963 46.9475 -79.8122 59.5376 -38.5151 35.5769C58.8502 -20.9169 62.1709 75.5176 140.114 85.2233C182.239 90.4701 232.326 59.3288 310.094 167.599",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186 106.333C-117.194 42.2365 -85.7348 61.7185 -39.4951 32.0332C55.2345 -28.7796 62.1709 69.498 140.114 79.2037C182.239 84.4505 232.326 53.3091 310.094 161.58",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186 99.2706C-117.194 35.1739 -85.7348 54.6559 -39.4951 24.9706C55.2345 -35.8422 63.0786 65.4936 141.022 75.2007C183.147 80.4475 229.711 49.5627 310.094 154.517",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-180.5 90.7835C-111.694 26.6869 -91.8712 53.4108 -39.4953 19.7874C51.6064 -38.6969 62.0401 64.8751 139.983 74.5823C173.743 78.7878 183.113 47.6863 215.842 74.5823C248.572 101.478 335.06 103.423 335.06 103.423",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-180.5 85.0481C-111.694 20.953 -90.9742 47.2546 -38.5968 13.6311C52.5049 -44.8532 63.169 60.539 141.112 70.2446C174.872 74.4501 183.618 41.0417 219.154 70.2446C254.689 99.4476 335.06 97.6859 335.06 97.6859",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-180.5 80.1305C-111.694 16.0339 -90.9742 42.337 -38.5968 8.712C52.5049 -49.7723 63.639 55.606 141.582 65.3117C175.342 69.5171 182.488 43.5857 211.821 60.3782C241.155 77.1708 292.752 88.996 332.802 84.104",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-176.174 68.4401C-107.368 4.34496 -95.323 40.0619 -42.9457 6.43847C48.156 -52.0458 66.4 51.047 144.343 60.7542C178.103 64.9596 182.49 42.051 211.824 58.8435C241.157 75.636 294.399 84.3494 334.449 79.4574",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-173.943 62.551C-105.137 -1.54568 -93.0926 34.1713 -40.7152 0.547823C50.3865 -57.9365 66.9947 46.5142 144.936 56.2214C178.697 60.4252 184.498 39.4288 213.831 56.2214C243.165 73.0139 296.628 78.4588 336.68 73.5668",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-173.943 57.8833C-105.137 -6.21185 -96.4993 23.4857 -40.7152 -4.11835C70.2509 -59.03 67.9501 38.8605 145.893 48.5677C179.653 52.7716 186.731 37.1971 216.063 53.9896C245.397 70.7822 296.628 73.7926 336.68 68.9006",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-173.943 44.5838C-105.137 -19.5129 -95.908 11.349 -40.7152 -17.4194C73.1723 -76.7807 65.2668 30.4193 143.341 38.9991C172.365 42.1893 187.966 26.0541 221.166 45.0599C254.365 64.0658 296.627 60.4931 336.678 55.6011",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-173.943 34.1933C-105.137 -29.9033 -98.9322 -5.79354 -40.7152 -27.8098C86.2494 -75.8251 65.2668 20.0288 143.341 28.6086C172.365 31.7988 187.966 15.6637 221.166 34.6695C254.365 53.6753 296.627 50.1027 336.678 45.2107",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-173.943 25.4823C-105.137 -38.6144 -98.9322 -14.5031 -40.7152 -36.5209C86.2494 -84.5362 65.2668 11.3178 143.341 19.8976C172.365 23.0877 187.966 6.9526 221.166 25.9584C254.365 44.9642 296.627 41.3916 336.678 36.4996",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-173.943 16.6218C-105.137 -47.4749 -98.9322 -23.3635 -40.7152 -45.3814C86.2494 -93.3966 65.2668 2.45728 143.341 11.0371C172.365 14.2273 187.966 -1.90942 221.166 17.0979C254.365 36.1038 296.627 32.5312 336.678 27.6392",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-170.989 7.02231C-102.183 -57.0743 -95.9781 -32.963 -37.7611 -54.9808C89.2035 -102.996 68.2209 -7.14221 146.296 1.4376C175.321 4.62776 190.92 -11.5074 224.121 7.49846C257.322 26.5043 299.584 22.9317 339.635 18.0397",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-168.772 -2.60373C-99.9681 -66.6989 -93.7614 -42.5891 -35.5443 -64.6054C91.4203 -112.621 70.4377 -16.7667 148.513 -8.1869C177.538 -4.99674 193.137 -21.1319 226.338 -2.12605C259.537 16.8798 301.801 13.3072 341.85 8.41516",
    stroke: "white",
    strokeWidth: 0.8
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.647 42L47.9999 61L37.9999 51",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7_5730",
    x: 2,
    y: 4,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_5730"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7_5730",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7_5730",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27 19) rotate(54.6599) scale(67.424)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41E99B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992404,
    stopColor: "#2A9F45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/success-tick.a902e0982142f53f2354767acea46169.svg";
export { ForwardRef as ReactComponent };